import React from 'react';

const SearchIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="#9aa3b4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;

const ResourcesHeroSection = ({ query, onQueryChange }) => (
    <section className="lp-hero lp-res-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-res-hero-inner">
            <div className="lp-badge" data-lp-reveal><span />Knowledge hub</div>
            <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Everything you need<br /><span style={{ color: '#FC7785' }}>to know.</span></h1>
            <p className="lp-lead" style={{ margin: '0 auto 32px' }} data-lp-reveal data-lp-delay="120">Guides, articles, and short films for companies, advisors, and investors.</p>
            <div className="lp-res-search" data-lp-reveal data-lp-delay="180">
                <SearchIcon />
                <input
                    type="text"
                    placeholder="Search resources…"
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                />
            </div>
        </div>
    </section>
);

export default ResourcesHeroSection;
